/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_P2dInputs */

const en_mk_sol_operasional_p2d = /** @type {(inputs: Mk_Sol_Operasional_P2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producing a monthly report whose format never changes still ties up one person for hours.`)
};

const id_mk_sol_operasional_p2d = /** @type {(inputs: Mk_Sol_Operasional_P2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyusun laporan bulanan yang formatnya selalu sama tetap memerlukan satu orang selama berjam-jam.`)
};

/**
* | output |
* | --- |
* | "Producing a monthly report whose format never changes still ties up one person for hours." |
*
* @param {Mk_Sol_Operasional_P2dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_p2d = /** @type {((inputs?: Mk_Sol_Operasional_P2dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_P2dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_p2d(inputs)
	return en_mk_sol_operasional_p2d(inputs)
});